import React from "react";
import T from 'i18n-react';
import { authenticateUser, redirectToCiamLogin } from "../../actions/authAction";
import { connect } from "react-redux";
import * as Constants from "../../../constants/Constants";
import { showToastError } from "../../library/utility";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "../../../../authConfig";
import jwt_decode from "jwt-decode";

@connect((store) => {
    return {
        isAuthenticated: store.auth.isAuthenticated,
        forgotPassFlg: store.auth.forgotPassFlg,
        passResetLogin: store.auth.passResetLogin,
        loginFailed: store.auth.loginFailed,
        loginFetching: store.auth.fetching,
        loginMes: store.auth.loginMes,
        loginSuccess: store.auth.loginSuccess,
        isAuthorized: store.auth.isAuthorized,
        fromCiamLogin: store.auth.fromCiamLogin
    };
})

export default class Login extends React.Component {
    constructor() {
        super();
    }

    state = {
        username: '',
        password: '',
        invalidUsername: false,
        invalidPassword: false
    }

    onChange = (event) => {
        const element = event.currentTarget;
        const elementId = element.id;
        const elementvalue = element.value;
        if (elementId === 'username') {
            const invalidUsername = elementvalue.trim().length > 0 ? false : true
            this.setState({
                username: elementvalue,
                invalidUsername: invalidUsername
            })
        } else if (elementId === 'password') {
            const invalidPassword = elementvalue.trim().length > 0 ? false : true
            this.setState({
                password: elementvalue,
                invalidPassword: invalidPassword
            })
        }
    }

    login = () => {
        const { username, password, invalidUsername, invalidPassword } = this.state;
        if (!invalidUsername && !invalidPassword) {
            this.props.dispatch(authenticateUser(username, password));
        }
    }

    validate = () => {
        const { username, password } = this.state;
        this.setState({
            invalidUsername: username.trim().length == 0 ? true : false,
            invalidPassword: password.trim().length == 0 ? true : false
        }, this.login)
    }

    loginPress = (event) => {
        if (event.which == 13) {
            this.validate();
        }
    }

    redirectToCiamLogin = (event) => {
        event.preventDefault();
        let ctx = this;
        this.sendGetRequest(Constants.CONFIG.discovery_endpoint, function (request, body) {
            // Save the endpoints for later use
            localStorage.setItem("authorization_endpoint", body.authorization_endpoint);
            localStorage.setItem("token_endpoint", body.token_endpoint);
            localStorage.setItem("end_session_endpoint", body.end_session_endpoint);
            localStorage.setItem("userinfo_endpoint", body.userinfo_endpoint);
            localStorage.setItem("jwks_uri", body.jwks_uri);
            sessionStorage.setItem("platform", Constants.SKID);

            ctx.sendGetRequest(body.jwks_uri, function (request, res) {
                for (let i = 0; i < res.keys.length; i++) {
                    if (res.keys[i].x5c !== undefined) {
                        localStorage.setItem("public_key_id", res.keys[1].kid);
                        localStorage.setItem("certificate", res.keys[1].x5c[0]);
                        break;
                    }
                }

                // save the state
                localStorage.setItem("ciam_state", Constants.CONFIG.state);

                var params = {
                    response_type: "code",
                    client_id: encodeURIComponent(Constants.CONFIG.client_id),
                    state: encodeURIComponent(Constants.CONFIG.state),
                    scope: encodeURIComponent(Constants.CONFIG.requested_scopes),
                    redirect_uri: encodeURIComponent(Constants.CONFIG.redirect_uri),
                    style_id: encodeURIComponent(Constants.CONFIG.styleId)
                }

                var finalParams = Object.keys(params).map(key => key + '=' + params[key]).join('&');
                // Build the authorization URL
                var url = localStorage.getItem("authorization_endpoint") + "?" + finalParams;
                // Redirect to the authorization server
                window.location = url;
            });
        }, function (request, error) {
            // This could be an error response from the OAuth server, or an error because the 
            // request failed such as if the OAuth server doesn't allow CORS requests
            showToastError(error.error_description);
        });
    }

    redirectToAzureLogin = (event) => {
        event.preventDefault();
        let ctx = this;
        msalConfig.auth.redirectUri = process.env.AZURE_REDIRECT_URL;
        const msalInstance = new PublicClientApplication(msalConfig);
        msalInstance.loginPopup(loginRequest)
        .then(body => {
            sessionStorage.setItem("platform", Constants.AZURE);
            sessionStorage.setItem("email", body.account.idTokenClaims.email);
            sessionStorage.setItem("access_token", body.accessToken);
            sessionStorage.setItem("id_token", body.idToken);
            sessionStorage.setItem("isAuthenticated", true);
            sessionStorage.setItem("ciam_email_id", body.account.idTokenClaims.email);
            sessionStorage.setItem("jwks_uri", msalConfig.auth.authority + "/discovery/v2.0/keys");
      
            ctx.sendGetRequest(sessionStorage.getItem("jwks_uri"), function (request, res) {
                for (let i = 0; i < res.keys.length; i++) {
                    if (res.keys[i].kid !== null) {
                        localStorage.setItem("public_key_id", res.keys[i].kid);
                        localStorage.setItem("certificate", res.keys[i].x5c[0]);
                        break;
                    }
                }
                window.location.href = "/packageinfo";
            });
      
        });
      }

    // Make a GET request and parse the response as JSON
    sendGetRequest(url, success, error) {
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
        request.onload = function () {
            var body = {};
            try {
                body = JSON.parse(request.response);
            } catch (e) { }
            if (request.status == 200) {
                success(request, body);
            } else {
                error(request, body);
            }
        }
        request.onerror = function () {
            error(request, {});
        }
        request.send();
    }

    render() {
        const { username, password, invalidUsername, invalidPassword } = this.state;
        let usernameCSS = invalidUsername ? ["form-control", "border-danger"] : ["form-control"];
        let passwordCSS = invalidPassword ? ["form-control", "border-danger"] : ["form-control"]
        return (
            <div class="loginDiv">
                <div class="container">
                    {(this.props.loginFailed && !this.props.isAuthenticated && !this.props.fromCiamLogin ?
                        <div
                            role="alert"
                            class="alert alert-danger"
                            id="resetPasswordError">
                            {this.props.loginMes != '' ? "OOps! Something went wrong." : "Invalid Username/Password."}
                        </div> : <div />)}

                        {(this.props.loginFailed && !this.props.isAuthorized && this.props.fromCiamLogin?
                        <div
                            role="alert"
                            class="alert alert-danger"
                            id="resetPasswordError">
                            {this.props.loginMes != '' ? "OOps! Something went wrong." : "You are not authorized to view this page!"}
                        </div> : <div />)}

                    <div>
                        <div class="form-group ">
                            <label>Username</label>
                            <input
                                id="username"
                                type="text"
                                value={username}
                                onChange={this.onChange}
                                className={usernameCSS.join(" ")}
                                autoFocus={true}
                            />

                        </div>
                        <div class="form-group ">
                            <label>Password</label>
                            <input
                                id="password"
                                type="password"
                                value={password}
                                onChange={this.onChange}
                                className={passwordCSS.join(" ")}
                                onKeyPress={this.loginPress}
                            />
                        </div>
                        <div style={{ marginTop: '1rem' }}>
                            {
                                this.props.loginFailed || !this.props.loginFetching ?
                                    <button
                                        id="loginBtn"
                                        class="loginButton"
                                        onClick={this.validate}>
                                        <span id="login-label">
                                            {T.translate("login.sign_in")}
                                        </span>
                                        <div class="login-loader d-none"></div>
                                    </button>
                                    :
                                    <button
                                        id="loginBtn"
                                        class="loginButton"
                                        onClick={this.validate}>
                                        <span id="login-label">
                                            {T.translate("login.signing_in")}
                                        </span>
                                        <div class="login-loader d-inline-flex"></div>
                                    </button>
                            }
                        </div>
                        <div style={{ marginTop: '1rem' }}>
                            <a href="#" onClick={this.redirectToCiamLogin}>
                                Sign in with SingleKey ID
                            </a>
                        </div>
                        <div style={{ marginTop: '1rem' }}>
                            <a href="#" onClick={this.redirectToAzureLogin}>
                                Sign in with Bosch Account
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
